import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_ALL_APPLICATIONS,
    userApplicationsReceived,
    startLoading,
    stopLoading
} from '../actions'

import {
    FETCH_APPLICATION_STATUS_ID,
} from '../store/loaders'




function * fetchUserApplications (payload){
    yield put(startLoading({id:FETCH_APPLICATION_STATUS_ID}))
    try{
       const response=  yield call(DCore.get, `/applications/${payload.data}/all`)
        yield put(stopLoading({id:FETCH_APPLICATION_STATUS_ID}))
        yield put (userApplicationsReceived(response.data))

    }catch(e){
        yield put(stopLoading({id:FETCH_APPLICATION_STATUS_ID}))
        console.log("some thing went wrong", e)
    }
}



export function * applicationStatusSaga(){
    yield takeLatest(FETCH_ALL_APPLICATIONS,fetchUserApplications)
}